import React, { Component } from 'react';
import { Form, Tooltip } from 'antd';
import { SvgIconText } from 'freesia-ui';
import PropertyGridUtils from "./PropertyGridUtils";
import PropertyItem from "./PropertyItem";


export default class PropertySheet extends Component {

    state = {

    };

    constructor(props, context) {
        super(props, context);
    }

    renderEditor(property) {

        const getter = PropertyGridUtils.getEditor(property);
        return getter(property, this.props.propertyGrid);
    }

    renderLabel(title, c) {
        if (this.props.orient === "v" && this.props.showDescription) {
            return (
                <div className="layout-v">
                    <Tooltip title={title || c.name} placement="left">
                        <div className="layout-h center">
                            <SvgIconText className={c.dirty ? "property-item-dirty-name" : ""} showIcon={!!c.svg} type={c.svg} spacing='md' text={(c.alias || c.name)} />
                            {c.url ? <a className="sp-left" href={c.url} target="_blank"> <SvgIconText type={"#anticon-Info1"} size="sm" /></a> : null}
                        </div>
                    </Tooltip>
                    {c.description ? <div className="second-text text-nowrap hstretch description" title={c.description}>{c.description}</div> : null}
                </div>
            )
        }
        else
            return (
                <Tooltip title={title || c.name} placement="left">
                    <div className="layout-h center">
                        <SvgIconText className={c.dirty ? "property-item-dirty-name" : ""} style={{ pointerEvents: 'auto' }} showIcon={!!c.svg} type={c.svg} spacing='md' text={(c.alias || c.name)} />
                        {c.url ? <a className="sp-left" href={c.url} target="_blank" style={{ pointerEvents: 'auto' }} > <SvgIconText type={"#anticon-Info1"} size="sm" /></a> : null}
                    </div>
                </Tooltip>
            )
    }

    render() {

        const formItemLayout = this.props.layout;
        let items = this.props.source.items;
        items.sort((a, b) => {
            return (a.zIndex === undefined ? 9999999 : a.zIndex) - (b.zIndex === undefined ? 9999999 : b.zIndex);
        });

        return (
            <div className={"propertygrid-sheet " + (this.props.className || "")}  >
                <div className="title">{this.props.source.name}</div>
                <div>
                    <Form layout='horizontal' colon={false}>
                        {
                            items.map(c => {
                                let title = c.description || c.alias;
                                if (title) {
                                    title = `${title}`;
                                }
                                if (c.dirty && c.dirtyText) {
                                    title = `[已过时][${c.dirtyText}] ${title}`;
                                }
                                else if (c.dirty) {
                                    title = `[已过时] ${title}`;
                                }
                                return <PropertyItem key={c.name}
                                    source={c}
                                    label={this.renderLabel(title, c)}
                                    {...(c.formItemLayout || formItemLayout)}>
                                    <div>
                                        {this.renderEditor(c)}
                                    </div>
                                </PropertyItem>
                            })
                        }
                    </Form>
                </div>
            </div>
        );
    }
}
